export default __webpack_public_path__ + "static/media/Icon ionic-md-eye.2d6acfc1.svg";